<template>
  <div class="itemBankDialog">
      <el-dialog width="647px" title="请选择要考试的试卷" :visible.sync="dialogStatus" :before-close="clearDialog">
        <div class="content">
            <el-collapse class="outside" v-model="activeNames" v-if="chapterData.length>0">
                <!-- <el-collapse-item :title="item.sectionname" v-for="(item, index) in chapterData" :key="index" :name="index">
                    <ul>
                        <li v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">
                            <span class="number">{{subIndex+1}}.</span>
                            <p class="text">{{subItem.taskname}}</p>
                            <span class="icon" @click="startExam(subItem.innerid)">开始考试</span>
                        </li>
                        <div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无章节任务</div>
                    </ul>
                </el-collapse-item> -->
                <el-collapse-item class="outsideItem" v-for="(item, index) in chapterData" :key="index" :name="index">
                    <template slot="title">
                        <div class="itemTitle">
                            <img :src="activeNames.indexOf(index) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                            <span :class="{'sectionname': !item.taskinfolist.length}">{{item.sectionname}}</span>
                        </div>
                    </template>
                    <div v-for="(obj, i) in item.taskinfolist" :key="i">
                        <el-collapse class="inside" v-model="item.activeNames">
                            <el-collapse-item :name="i">
                                <template slot="title">
                                    <div class="insideItemTitle">
                                        <div class="left">
                                            <img v-if="obj.childrenlist.length" :src="item.activeNames.indexOf(i) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                                            <span :class="{'childrenlist': obj.childrenlist.length, 'taskname': !obj.childrenlist.length}">{{obj.taskname}}</span>
                                        </div>
                                        <div class="right" v-if="obj.exampaperinnerid">
                                            <div v-if="obj.status === 0" class="doExercise" @click.stop="startExam(obj.innerid)">做题</div>
                                            <div v-if="obj.status === 1" class="continue" @click.stop="startExam(obj.innerid)">继续</div>
                                            <div v-if="obj.status === 11" class="doExercise" @click.stop="startExam(obj.innerid)">重做</div>
                                        </div>
                                    </div>
                                </template>
                                <div class="subjectItem" v-for="(options, j) in obj.childrenlist" :key="j">
                                    <div class="taskname">{{options.taskname}}</div>
                                    <div class="right">
                                        <div class="btn" v-if="options.exampaperinnerid">
                                            <div v-if="options.status === 0" class="doExercise" @click="startExam(options.innerid)">做题</div>
                                            <div v-if="options.status === 1" class="continue" @click="startExam(options.innerid)">继续</div>
                                            <div v-if="options.status === 11" class="doExercise" @click="startExam(options.innerid)">重做</div>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div v-if="chapterData&&chapterData.length === 0" class="no_data_box">
                <img :src="require('@/common/images/other/no_data.png')" alt="">
                <span>当前题库暂无目录</span>
            </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'itemBankDialog',
  data () {
    return {
        dialogStatus: false,    // 弹窗状态
        activeNames: [0], // 默认展开第一个折叠面板
        chapterData:[],
        bankid:'',
    }
  },
  mounted () {},
  methods: {
      startItemBankDialog(id,val) {   // 开启考试弹窗
        this.dialogStatus = true;
        this.bankid=id;
        this.chapterData=val;
      },
      clearDialog() {   // 关闭弹窗
        this.dialogStatus = false
      },
      // 开始考试
      startExam(innerid){
          this.$router.push({
              name: 'ExaminationPaperInformation',query: {bankid: this.bankid, taskid: innerid}
          })
      },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.itemBankDialog {
    .el-collapse-item__header,
    .el-collapse {
        border: none;
    }
    .el-collapse-item__wrap {
        border: none;
    }
    .el-collapse-item__content {
        padding-bottom: 0;
    }
    .el-dialog__body {
        // padding-top: 0;
        // padding-bottom: 0;
        padding: 0;
        overflow-x: hidden;
    }
    
    .content {
        overflow-y: auto;
        height: 478px;
        // width: 102.5%;
        // padding-right: 16px;
        // box-sizing: border-box;
        font-weight: bold;
        .no_task_box{
            height: 40px;
            line-height: 40px;
            color: #999;
            padding: 0 20px;
        }
        .no_data_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            position: absolute;
            & > img {
                width: 130px;
                height: 76px;
                margin-bottom: 20px;
            }
            & > span {
                color: #CADAEEFF;
                line-height: 20px;
            }
        }
    }
    .el-collapse-item__header,
    .text {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
    }
    .el-collapse-item__header {
        font-weight: bold;

        // &::before {
        //     content: "";
        //     margin-right: 8px;
        //     width: 0;
        //     height: 0;
        //     border-style: solid;
        //     border-color: #909399 transparent transparent;
        //     border-width: 5px;
        //     vertical-align: -3px;
        //     display: inline-block;
        // }
        i {
            display: none;
        }
    }
    ul {
        li {
            display: flex;
            margin-bottom: 6px;
            padding: 10px 12px;
            background: #F8F8F8;
            cursor: pointer;

            &:hover {
                background: #F1F8FF;
                .icon {
                    display: block;
                }
            }
            .text {
                margin-left: 10px;
                width: 420px;
            }
            .number {
                width: 25px;
                color: #999999;
            }

            .icon {
                display: none;
                width: 120px;
                text-align: right;
                color: #409EFF;
                background: url('../../../../common/images/other/see_icon.png') no-repeat;
                background-position-x: 40px;
                background-position-y: center;
                background-size: 18px;
            }

        }
    }
    .outsideItem {
        .el-collapse-item__header {
            border-bottom: 1px solid #E5E5E5;
        }
        .itemTitle {
            padding-left: 18px;
            display: flex;
            align-items: center;
            img {
                margin-right: 12px;
            }
            .sectionname {
                margin-right: 32px;
            }
        }
        .inside {
            .el-collapse-item__header {
                margin-bottom: 1px;
            }
            .insideItemTitle {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-left: 50px;
                .left {
                    display: flex;
                    align-items: center;
                    img {
                        margin-right: 12px;
                    }
                    span {
                        color: #333333;
                    }
                    .taskname {
                        margin-left: 32px;
                    }
                }
                .right {
                    padding-right: 10px;
                    .continue {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #FFECD4;
                        background: #F18B05;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .doExercise {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #DFECFD;
                        background: #409EFF;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                }
            }
            .el-collapse-item__content {
                margin-bottom: 1px;
            }
            .subjectItem {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 56px;
                border-bottom: 1px solid #E5E5E5;
                .taskname {
                    padding-left: 98px;
                    color: #333333;
                }
                .right {
                    padding-right: 10px;
                    .continue {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #FFECD4;
                        background: #F18B05;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .doExercise {
                        width: 80px;
                        height: 32px;
                        border: 3px solid #DFECFD;
                        background: #409EFF;
                        color: #fff;
                        text-align: center;
                        line-height: 26px;
                        box-sizing: border-box;
                        font-size: 14px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>